import {
  faAirFreshener,
  faAlignCenter,
  faAlignLeft,
  faBars,
  faBell,
  faBiking,
  faBullhorn,
  faCar,
  faClone,
  faComment,
  faComments,
  faCopy,
  faCreditCard,
  faCubes,
  faEnvelopeOpen,
  faFileInvoiceDollar,
  faGift,
  faGifts,
  faHandsHelping,
  faImages,
  faIndustry,
  faLaptop,
  faList,
  faMapMarked,
  faMapMarker,
  faSitemap,
  faStore,
  faTruck,
  faUpload,
  faUser,
  faUserClock,
  faUsers,
  faUserShield,
  faUserTag,
  faWeightHanging,
} from "@fortawesome/free-solid-svg-icons";

import Dashboard from "../components/Dashboard";
import NeighborhoodPage from "../pages/Neighborhood";
import BannerPage from "../pages/banners";
import BrandPage from "../pages/brands";
import CampaignPage from "../pages/campaigns";

import CorporatePage from "../pages/corporates";
import DriversPage from "../pages/drivers";
import FileManagerPage from "../pages/file-manager";
import DeliveryReportPage from "../pages/finance/delivery-report";
import RevenueReportPage from "../pages/finance/revenue-report";
import SalesReportPage from "../pages/finance/sales-report";
import MyTransactionPage from "../pages/finance/transactions";

import GiftVoucherPage from "../pages/gifts";

import GlobalCategoryPage from "../pages/global-category";
import GlobalSubCategoryPage from "../pages/global-category/global-sub-categories";
import GlobalProductsPage from "../pages/global-products";
import GlobalProductAddPage from "../pages/global-products/add";
import GlobalProductDetailsPage from "../pages/global-products/details";
import GlobalProductEditPage from "../pages/global-products/edit";
import HubsPage from "../pages/hubs";
import KeywordPage from "../pages/keywords";
import PopularKeywordPage from "../pages/keywords/popular";
import ProductKeywordPage from "../pages/keywords/product-keywords";
import AreaPage from "../pages/locations/areas";
import RegionPage from "../pages/locations/regions";
import MerchantsPage from "../pages/merchants";
import OrderPage from "../pages/orders";
import PaymentMethodPage from "../pages/paymentMethod";
import ProductsPage from "../pages/products";

import PromoCodePage from "../pages/promocode";
import ShopListPage from "../pages/shops";
import UsersPage from "../pages/users/users";

import SMSNotificationPage from "../pages/notifications/sms";
import FeedbackPage from "../pages/feedback";
import FeedbackTypePage from "../pages/feedback/types";
import AdminPage from "../pages/admins";
import AdminGroupPage from "../pages/admins/group";
import AdminServicePage from "../pages/admins/services";
import ProductEditPage from "../pages/products/edit";
import ProductEditMultiple from "../pages/products/edit-multiple";
import EmailNotificationPage from "../pages/notifications/email";
import TimeSlotPage from "../pages/delivery/time-slot";

import VehicleTypePage from "../pages/delivery/vehicle-type";
import ServiceLocationPage from "../pages/delivery/service-location";
import ZonePage from "../pages/delivery/zone";
import OrderCreateManualPage from "../pages/orders/create";
import OrderDetailsPage from "../pages/orders/details";
import MySettlementPage from "../pages/finance/my-settlements";
import PushNotificationPage from "../pages/notifications/index";
import VRHistoryPage from "../pages/finance/vr-history";
import OrderVatTaxPage from "../pages/finance/order-vat-tax";
import VatTaxDeliveryReportPage from "../pages/finance/delivery-vat-tax";
import RestrictedProductPage from "../pages/products/restricted-product";
import ProductAddPage from "../pages/products/add";
import CampaignDetailsPage from "../pages/campaigns/details";
import CampaignProductPage from "../pages/campaigns/products";
import UserDetailsPage from "../pages/users/details";
import CustomerOrderPage from "../pages/users/orders";
import NeighborhoodAddPage from "../pages/Neighborhood/add";
import NeighborhoodDetailsPage from "../pages/Neighborhood/detailsViewNighborhood";

export const isAllowedService = (name: string) => {
  const services = localStorage.getItem("services");

  if (services) {
    const list = JSON.parse(services);
    const data = list.find((item) => item.serviceName === name);
    if (data) {
      return true;
    }
  }
  return false;
};

export const allowedActions = (name: string) => {
  const services = localStorage.getItem("services");

  if (services) {
    const list = JSON.parse(services);
    const data = list.filter((item) => item.serviceName === name);
    if (data.length > 0) {
      data.map((d) => d.action);
    }
  }
  return [];
};

export const isEditableService = (name: string) => {
  const services = localStorage.getItem("services");

  if (services) {
    const list = JSON.parse(services);
    const data = list.find(
      (item) => item.serviceName === name && item.action === "all"
    );

    if (data) {
      return true;
    }
  }
  return false;
};

export const getAllServices = () => {
  const services = localStorage.getItem("services");
  if (services) {
    return JSON.parse(services);
  }
  return [];
};

type AdminService = {
  name: string;
  path?: string;
  icon?: any;
  component?: any;
  sub?: AdminService[];
  isParent?: boolean;
};

export const adminServices: AdminService[] = [
  {
    name: "Dashboard",
    path: "/",
    icon: faLaptop,
    component: Dashboard,
  },
  {
    name: "Orders",
    path: "/orders",
    icon: faCopy,
    sub: [
      {
        name: "All",
        path: "/all",
        icon: faCopy,
        component: OrderPage,
        isParent: true,
      },
      {
        name: "Order Create",
        path: "/create",
        component: OrderCreateManualPage,
      },
      {
        name: "Order Details",
        path: "/:orderId",
        component: OrderDetailsPage,
      },
      {
        name: "Payment Status",
        path: "/payment-status",
      },
      {
        name: "Assign DM",
        path: "/assign-dm",
      },
      {
        name: "Change Status",
        path: "/change-status",
      },
      {
        name: "Order Transfer",
        path: "/transfer",
      },
    ],
  },
  {
    name: "Hub Management",
    path: "/hubs",
    icon: faIndustry,
    sub: [
      {
        name: "Hub All",
        path: "/",
        icon: faIndustry,
        component: HubsPage,
        isParent: true,
      },
      {
        name: "Hub Create",
        path: "/create",
      },
    ],
  },
  {
    name: "Merchant Management",
    path: "/merchants",
    icon: faUserTag,
    component: MerchantsPage,
  },

  {
    name: "Neighborhood",
    path: "/neighborhood",
    icon: faLaptop,
    sub: [
      {
        name: "Neighborhood All",
        path: "/",
        icon: faLaptop,
        component: NeighborhoodPage,
        isParent: true,
      },
      {
        name: "Neighborhood Add",
        path: "/add",
        component: NeighborhoodAddPage,
      },

      {
        name: "Neighborhood details",
        path: "/:neighborhoodId/:shopType/details",
        component: NeighborhoodDetailsPage,
      },
    ],
  },

  {
    name: "Shops",
    path: "/shops",
    icon: faStore,
    component: ShopListPage,
  },
  {
    name: "Global Categories",
    path: "/categories",
    icon: faSitemap,
    sub: [
      {
        name: "Categories",
        path: "/",
        icon: faBars,
        component: GlobalCategoryPage,
      },
      {
        name: "Sub Categories",
        path: "/sub",
        icon: faBars,
        component: GlobalSubCategoryPage,
      },
    ],
  },

  {
    name: "Global Products",
    path: "/global-products",
    icon: faHandsHelping,
    sub: [
      {
        name: "All Global Product",
        path: "/all",
        icon: faClone,
        component: GlobalProductsPage,
      },
      {
        name: "Global Product Details",
        path: "/:slug/details",
        component: GlobalProductDetailsPage,
      },
      {
        name: "Global Product Edit",
        path: "/:slug/edit",
        component: GlobalProductEditPage,
      },
      {
        name: "Global Product Add",
        path: "/add",
        component: GlobalProductAddPage,
      },
    ],
  },
  {
    name: "Products",
    path: "/products",
    icon: faWeightHanging,
    sub: [
      {
        name: "All Products",
        path: "/all",
        icon: faAirFreshener,
        component: ProductsPage,
      },
      // {
      //   name: "Details",
      //   path: "/:slug/details",
      //   component: ProductDetailsPage,
      // },
      {
        name: "Product Add",
        path: "/add",
        component: ProductAddPage,
      },
      {
        name: "Product Edit",
        path: "/:slug/edit",
        component: ProductEditPage,
      },
      {
        name: "Edit Multi-Shop",
        path: "/:slug/edit=multiple-shop",
        component: ProductEditMultiple,
      },

      {
        name: "Restricted Products",
        path: "/restrict",
        icon: faAirFreshener,
        component: RestrictedProductPage,
      },
    ],
  },
  {
    name: "Corporate List",
    path: "/corporates",
    icon: faHandsHelping,
    component: CorporatePage,
  },
  {
    name: "Brands",
    path: "/brands",
    icon: faCubes,
    component: BrandPage,
  },
  {
    name: "Banners",
    path: "/banners",
    icon: faImages,
    component: BannerPage,
  },
  {
    name: "Promotions",
    path: "/promotions",
    icon: faGifts,
    sub: [
      {
        name: "Campaign",
        path: "/campaign",
        icon: faBullhorn,
        component: CampaignPage,
      },
      {
        name: "Campaign Details",
        path: "/campaigns/details/:campaignId",
        component: CampaignDetailsPage,
      },
      {
        name: "Campaign Product",
        path: "/campaigns/:campaignId/products",
        component: CampaignProductPage,
      },
      {
        name: "Promo Code",
        path: "/promo-code",
        icon: faGifts,
        component: PromoCodePage,
      },
      {
        name: "Gift",
        path: "/gift",
        icon: faGift,
        component: GiftVoucherPage,
      },
    ],
  },
  {
    name: "Delivery",
    path: "/delivery",
    icon: faTruck,
    sub: [
      {
        name: "Delivery Hero",
        path: "/drivers",
        icon: faBiking,
        component: DriversPage,
      },
      {
        name: "Time Slot",
        path: "/time-slot",
        icon: faUserClock,
        component: TimeSlotPage,
      },
      {
        name: "Service Location",
        path: "/service-location",
        icon: faMapMarker,
        component: ServiceLocationPage,
      },
      {
        name: "Service Zone",
        path: "/zone",
        icon: faMapMarked,
        component: ZonePage,
      },
      {
        name: "Vehicle Type",
        path: "/vehicle-type",
        icon: faCar,
        component: VehicleTypePage,
      },
    ],
  },
  {
    name: "Finance",
    path: "/finance",
    icon: faFileInvoiceDollar,
    sub: [
      {
        name: "My Transactions",
        path: "/transactions",
        icon: faAlignLeft,
        component: MyTransactionPage,
      },
      {
        name: "Settlement Request",
        path: "/my-settlement",
        icon: faBell,
        component: MySettlementPage,
      },
      {
        name: "VR History",
        path: "/vr-history",
        icon: faAlignCenter,
        component: VRHistoryPage,
      },
      {
        name: "Delivery Report",
        path: "/delivery-report",
        icon: faAlignCenter,
        component: DeliveryReportPage,
      },
      {
        name: "Sales Report",
        path: "/sales-report",
        icon: faAlignCenter,
        component: SalesReportPage,
      },
      {
        name: "Revenue Report",
        path: "/revenue-report",
        icon: faAlignCenter,
        component: RevenueReportPage,
      },
      {
        name: "Order Vat-Tax",
        path: "/order-vat-tax",
        icon: faAlignCenter,
        component: OrderVatTaxPage,
      },
      {
        name: "Delivery Vat-Tax",
        path: "/delivery-vat-tax-report",
        icon: faAlignCenter,
        component: VatTaxDeliveryReportPage,
      },
    ],
  },

  {
    name: "Locations",
    path: "/locations",
    icon: faMapMarker,
    sub: [
      {
        name: "Thana",
        path: "/regions",
        icon: faAlignLeft,
        component: RegionPage,
      },
      {
        name: "Area",
        path: "/areas",
        icon: faAlignLeft,
        component: AreaPage,
      },
    ],
  },

  {
    name: "Keywords",
    path: "/keywords",
    icon: faAlignCenter,
    sub: [
      {
        name: "All Keywords",
        path: "/all",
        icon: faAlignLeft,
        component: KeywordPage,
      },
      {
        name: "Popular",
        path: "/popular",
        icon: faAlignLeft,
        component: PopularKeywordPage,
      },
      {
        name: "Product",
        path: "/product",
        icon: faAlignLeft,
        component: ProductKeywordPage,
      },
    ],
  },
  {
    name: "Notifications",
    path: "/notifications",
    icon: faBell,
    sub: [
      {
        name: "SMS",
        path: "/sms",
        icon: faComments,
        component: SMSNotificationPage,
      },
      {
        name: "Email",
        path: "/email",
        icon: faEnvelopeOpen,
        component: EmailNotificationPage,
      },
      {
        name: "Push Notifications",
        path: "/push",
        icon: faBell,
        component: PushNotificationPage,
      },
    ],
  },
  {
    name: "Feedbacks",
    path: "/feedbacks",
    icon: faComments,
    sub: [
      {
        name: "Feedback List",
        path: "/all",
        icon: faComment,
        component: FeedbackPage,
      },
      {
        name: "Feedback Type",
        path: "/type",
        icon: faAlignLeft,
        component: FeedbackTypePage,
      },
    ],
  },
  {
    name: "Administration",
    path: "/administration",
    icon: faUserShield,
    sub: [
      {
        name: "User Management",
        path: "/admins",
        icon: faUser,
        component: AdminPage,
      },
      {
        name: "User Groups",
        path: "/groups",
        icon: faUsers,
        component: AdminGroupPage,
      },
      {
        name: "User Services",
        path: "/services",
        icon: faList,
        component: AdminServicePage,
      },
    ],
  },
  {
    name: "Customer List",
    path: "/users",
    icon: faUsers,
    sub: [
      {
        name: "All",
        path: "/",
        icon: faUsers,
        component: UsersPage,
        isParent: true,
      },
      {
        name: "Details",
        path: "/:id/details",
        component: UserDetailsPage,
      },
      {
        name: "Orders",
        path: "/:id/orders",
        component: CustomerOrderPage,
      },
    ],
  },
  {
    name: "Payment Methods",
    path: "/payment-methods",
    icon: faCreditCard,
    component: PaymentMethodPage,
  },
  {
    name: "Upload Images",
    path: "/file-manager",
    icon: faUpload,
    component: FileManagerPage,
  },
];

export const getAllServicesList = () => {
  return adminServices?.flatMap((service) => {
    if (service.sub && service.sub.length) {
      return service.sub.map((sub) => `${service.name} ${sub.name}`);
    } else {
      return service.name;
    }
  });
};

// console.log("All Services List", getAllServicesList());
